import * as Yup from 'yup';
import * as utils from './StrUtils.js';

const RSInput = ({ qObj }) => {
  let valObj = Yup.string();

  valObj = utils.transformCase(valObj, qObj);
  valObj = utils.setRequired(valObj, qObj);
  valObj = utils.setCharLimit(valObj, qObj.char_limit);
  return valObj;
};

export default RSInput;